import { ScrollDispatcher } from '@angular/cdk/overlay';
import { Directive, ElementRef, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { distinctUntilChanged, filter, map, takeWhile } from 'rxjs/operators';

@Directive({
  selector: '[shadowOnScroll]',
  standalone: false,
})
export class ShadowOnScrollDirective implements OnInit, OnDestroy {
  alive = true;
  @Input('shadowOnScroll') pause!: boolean;

  constructor(
    private el: ElementRef,
    private renderer2: Renderer2,
    private scrollService: ScrollDispatcher
  ) {}

  ngOnInit() {
    this.scrollService
      .scrolled(0)
      .pipe(
        filter(() => !this.pause),
        map((c) => (document.documentElement.scrollTop || document.body.scrollTop) > 1),
        distinctUntilChanged(),
        takeWhile(() => this.alive)
      )
      .subscribe((isElevated: boolean) => {
        if (isElevated) {
          this.renderer2.addClass(this.el.nativeElement, 'shadow');
        } else {
          this.renderer2.removeClass(this.el.nativeElement, 'shadow');
        }
      });
  }

  ngOnDestroy() {
    this.alive = false;
  }
}
